import { useCallback } from 'react';
import { useSweepApi } from '../sweep';
import { GlobalDto } from '../../reducers/global/globalReducerTypes';
import { useDispatch } from 'react-redux';
import { populateFieldsInfoFromGlobalDTO } from '../../sweep-fields/sweepFieldsInfoReducer';

const useGlobalApiFacade = () => {
  const sweepApi = useSweepApi();
  const dispatch = useDispatch();

  const get_global = useCallback(
    async (crmOrgId: string) => {
      const response = await sweepApi.get<GlobalDto>(`/global/${crmOrgId}`);

      const globalDto = response.data;
      dispatch(populateFieldsInfoFromGlobalDTO({ globalDto }));
      return globalDto;
    },
    [dispatch, sweepApi],
  );

  return { get_global };
};

export default useGlobalApiFacade;
